export enum PaymentPeriod {
  MONTH = 'MONTH',
  TWO_MONTHS = 'TWO_MONTHS',
  QUARTER = 'QUARTER',
  YEAR = 'YEAR',
  NOT_APPLICABLE = 'NOT_APPLICABLE',
}
